import { render, staticRenderFns } from "./_MSGDadosInvalidos.vue?vue&type=template&id=5a4bfce8"
import script from "./_MSGDadosInvalidos.vue?vue&type=script&lang=js"
export * from "./_MSGDadosInvalidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports